export default {"src":"/_next/static/media/arrow_left_gray.ee16e058.svg","height":12,"width":13,"blurWidth":0,"blurHeight":0};